import { Component, Input, OnInit } from '@angular/core';
import { KeyValue } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { HomeService } from 'src/app/services/home/home.service';
import { MotifTableModule, MotifDropdownModule, MotifIconModule } from '@ey-xd/ng-motif';
import { DocumentList } from 'src/app/interfaces/engagement-details.interface';
import { DOC_TYPES, COMPETENCIES } from './../../constants/endpoint.constants';
import { ToasterService } from 'src/app/components/toast/toaster.service';
import { ApiErrorMessage } from 'src/app/enums/api-status.enum';

@Component({
  selector: 'app-contractual-docs',
  templateUrl: './contractual-docs.component.html',
  styleUrls: ['./contractual-docs.component.scss']
})
export class ContractualDocsComponent implements OnInit {
  public docsData: DocumentList[] = [];
  public engagementId!: any;
  @Input() data: any = {
    'clientId': '',
    'isModal': false
  };
  public colDefs = [
    { field: "docId", headerName: "ID",flex:.5 },
    { field: "competency", headerName: "Competency",flex:.6},
    { field: "documentType" , headerName: "Type",flex:.6},
    { field: "url" , headerName: "Document",flex:1,  cellRenderer: (params:any)=> this.renderDocLink(params)},
  ];
  public documents: DocumentList[] = [];
  public selectedCompetency: string = 'Select';
  public selectedType: string = 'Select';
  public DOC_TYPES = DOC_TYPES
  public COMPETENCIES = COMPETENCIES;
  loading: boolean = false;

  constructor(private router: Router, private route: ActivatedRoute, private homeServiceRef: HomeService, private motifTableModule: MotifTableModule,
    private toasterServiceRef: ToasterService) { }

  ngOnInit(): void {
    this.loading = true;
    const id = this.route.snapshot.paramMap.get('id') || '';
    this.engagementId = id || this.data.clientId;
    console.log(this.engagementId);
    this.homeServiceRef.getDocumentsList(this.engagementId).subscribe({
      next: (data: DocumentList[]) => {
        this.loading = false;
        this.docsData = JSON.parse(JSON.stringify(data));
        this.documents = JSON.parse(JSON.stringify(data));
      },
      error: (err) => {
        this.toasterServiceRef.error(ApiErrorMessage.DEFAULT);
        this.loading = false;
      },
    });
  }

  updateDocuments(filter: string, criteria: string) {
    if (criteria === 'competency') {
      // this.selectedType = 'Select';
      this.selectedCompetency = filter;
      if (this.selectedCompetency !== 'Select') {
        if (this.selectedType !== 'Select')
          this.documents = JSON.parse(JSON.stringify(this.docsData.filter(item => item.competency === filter && item.documentType === this.selectedType)));
        else
          this.documents = JSON.parse(JSON.stringify(this.docsData.filter(item => item.competency === filter)));
      } else {
        if (this.selectedType !== 'Select')
          this.documents = JSON.parse(JSON.stringify(this.docsData.filter(item => item.documentType === this.selectedType)));
        else
          this.documents = JSON.parse(JSON.stringify(this.docsData));
      }
    } else if (criteria === 'type') {
      // this.selectedCompetency = 'Select';
      this.selectedType = filter;
      if (this.selectedType !== 'Select') {
        if (this.selectedCompetency !== 'Select')
          this.documents = JSON.parse(JSON.stringify(this.docsData.filter(item => item.documentType === filter && item.competency === this.selectedCompetency)));
        else
          this.documents = JSON.parse(JSON.stringify(this.docsData.filter(item => item.documentType === filter)));
      } else {
        if (this.selectedCompetency !== 'Select')
          this.documents = JSON.parse(JSON.stringify(this.docsData.filter(item => item.competency === this.selectedCompetency)));
        else
          this.documents = JSON.parse(JSON.stringify(this.docsData));
      }
    } else {
      this.selectedCompetency = 'Select';
      this.selectedType = 'Select';
      this.documents = JSON.parse(JSON.stringify(this.docsData));
    }
  }
  renderDocLink(param: any) {
    return param.value.length ? `<a target="_blank" href="${param.value}">${param.value.split("/").pop()}</a>` : '';
  }

  goHome() {
    this.router.navigate([`/home`, this.engagementId]);
  }

}
